import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Table, Form, message, Card, Button, Row, Col, Typography, Tabs, Breadcrumb, Checkbox, Avatar, Affix, Input, Select, Spin } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import ObjectFieldTab from '../Field/ObjectFieldsTab';
import RecordType from "./RecordType";
import CreateListView from './CreateListView';
import ObjectRelatedListTab from './ObjectRelatedListTab';
import { BASE_URL } from '../Components/Constant';
import ApiService from '../Components/apiService';
import CreateObjectDrawer from './CreateObjectDrawer';
import CreateLayout from './CreateLayout';
import SearchLayout from './SearchLayout';
import CompactLayout from './CompactLayout';
import ApprovalProcess from '../ApprovalProcesses/ApprovalProcess';
import TriggersList from './TriggersList';
import FlowUI from '../Flow/FlowUI';
import FlowsDisplay from '../Flow/FlowsDisplay';
import CustomButtonList from '../SetupComponent/CustomButtonList';
import { useSelector } from 'react-redux';
import SharingSettings from './SharingSettings';
import ObjectDetailsTab from './ObjectDetailsTab';
import ObjectRules from './ObjectRules';



const { Title } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

const ObjectFieldDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { record } = location.state || {};
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [form] = Form.useForm();
  const [availableFields, setAvailableFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [allFields, setAllFields] = useState([]);
  const [objectData, setObjectData] = useState({});
  const [isEditable, setIsEditable] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [dataset, setDataset] = useState([]);
  const fieldSecurity = useSelector((state) => state.data.items[0]);

  useEffect(() => {
    const fetchFields = async () => {
      setLoading(true);
      try {
        const apiServiceForAllFields = new ApiService(
          `${BASE_URL}/mt_fields/object/${record?.name}`,
          { 'Content-Type': 'application/json' },
          'GET'
        );
        const getSelectedValuesApiService = new ApiService(
          `${BASE_URL}/mt_objects/${record._id}`,
          { 'Content-Type': 'application/json' },
          'GET',
        );
        let responseForSelectedValues = await getSelectedValuesApiService.makeCall(navigate);
        const { search_layout_fields, recordCount, _id, is_system, key, ...rest } = responseForSelectedValues;
        const transformedObject = { ...rest };
        setObjectData(transformedObject);
        const selectedFieldNames = responseForSelectedValues.search_layout_fields || [];
        setSelectedFields(
          selectedFieldNames.map((name) => ({ name, isSelected: false }))
        );

        const response = await apiServiceForAllFields.makeCall(navigate);
        const allFields = response
          .filter((field) => field.name !== 'recordCount')
          .map((field) => ({ ...field, key: field._id, isSelected: false }));

        const availableFieldsFiltered = allFields.filter(
          (field) => !selectedFieldNames.includes(field.name)
        );

        setAvailableFields(availableFieldsFiltered);

      } catch (error) {
        const errorMessage = error && typeof error === 'object'
          ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
          : 'Failed to fetch fields due to an unknown error';
        message.error(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    fetchFields();
  }, []);

  

  const toggleSelection = (field, list, setList) => {
    if (!isEditMode) return;
    setList(
      list.map((item) =>
        item.name === field.name
          ? { ...item, isSelected: !item.isSelected }
          : item
      )
    );
  };

  const handleSave = () => {
    const selectedArray = selectedFields.map((field) => field.name);
    sendSelectedValues(selectedArray);
    setIsEditMode(false);
  };

  const sendSelectedValues = async (values) => {
    try {
      const requestBody = {
        search_layout_fields: values,
      };

      const apiService = new ApiService(
        `${BASE_URL}/mt_objects/${record._id}`,
        { 'Content-Type': 'application/json' },
        'PUT',
        { mt_object: requestBody }
      );

      const response = await apiService.makeCall();

      if (response && response._id) {
        message.success('Fields Updated Successfully');
      } else {
        message.error('Invalid Response From Server');
      }
    } catch (err) {
      // Handle access denied or other errors here
      if (err) {
        message.error('Access Denied: You do not have permission to update this record');
      }
      // else {
      //   message.error(`Error updating fields: ${err.message || err}`);
      // }
    }
  };


  const handleEdit = () => {
    setIsEditMode(true);
  };

 


  
  return (
    <div style={{margin:2,padding:10}}>
      <Breadcrumb style={{ marginBottom: '10px' }}>
        <Breadcrumb.Item>
          <Link to="/setup" style={{ fontWeight: 'bold' }}>
            Object Manager
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{record?.label || 'Object Details'}</Breadcrumb.Item>
      </Breadcrumb>

      <Title level={4}>{record?.label || 'Object Details'}</Title>
      <Tabs defaultActiveKey="1" tabPosition='left' style={{ height: '100vh',padding:0 }}>

        <TabPane tab="Details" key="1">
            <Card>
              <ObjectDetailsTab record={record} />
            </Card>
        </TabPane>

        <TabPane tab="Properties" key="2">
          <Card>
            <ObjectFieldTab object={record} />
          </Card>
        </TabPane>

        <TabPane tab="Related Lists" key="3">
          <Card>
            <ObjectRelatedListTab object={record} />
          </Card>
        </TabPane>

        <TabPane tab="Create List View" key="4">
          <Card>
            <CreateListView object={record} />
          </Card>
        </TabPane>

        <TabPane tab="Layouts" key="5">
          <Card>
            <CreateLayout object={record} />
          </Card>
        </TabPane>

        <TabPane tab="Compact Layout" key="6">
          <Card>
            <CompactLayout object={record} />
          </Card>
        </TabPane>

        <TabPane tab="Custom Action Button" key="7">
          <Card>
            <CustomButtonList object={record} />
          </Card>
        </TabPane>

        <TabPane tab="Search Result Layout" key="8">
          <Card>
            <Title level={4}>Search Result Layout</Title>
            <SearchLayout setAvailableFields={setAvailableFields} setIsEditMode={setIsEditMode} setSelectedFields={setSelectedFields} availableFields={availableFields} selectedFields={selectedFields} loading={loading} isEditMode={isEditMode} toggleSelection={toggleSelection} handleSave={handleSave} handleEdit={handleEdit} />
          </Card>
        </TabPane>

        <TabPane tab="Triggers" key="9">
          <Card>
            <TriggersList object={record} />
          </Card>
        </TabPane>

        <TabPane tab="Flows" key="10">
          <Card>
            <FlowsDisplay object={record} />
          </Card>
        </TabPane>
        
        <TabPane tab="Record Type" key="11">
          <Card>
            <RecordType object={record} />
          </Card>
        </TabPane>

         <TabPane tab="Rules" key="12">
          <Card>
            <ObjectRules object={record} />
          </Card>
        </TabPane>

        {/* <TabPane tab="Sharing Rules" key="12">
          <Card>
            <SharingSettings object={record} />
          </Card>
        </TabPane> */}

      </Tabs>
    </div>
  );
};

export default ObjectFieldDetail;